import { FieldType } from "@common/dto/field/type";

export const NOT_ALLOWED_FOR_PAGE_ADD_FIELD_TYPES = [FieldType.image];